export { useGetRecommendedUpNext, useGetSuggestedShowsAndFilms } from './RecommendationService'
export type {
  RecommendedUpNextContent,
  RecommendedUpNextResult,
  SuggestedShowsAndFilmsContent,
  SuggestedShowsAndFilmsResult,
} from './types'
